import { render, staticRenderFns } from "./AbnormalTableCustomers.vue?vue&type=template&id=66f3c08f&scoped=true&"
import script from "./AbnormalTableCustomers.vue?vue&type=script&lang=js&"
export * from "./AbnormalTableCustomers.vue?vue&type=script&lang=js&"
import style0 from "./AbnormalTableCustomers.vue?vue&type=style&index=0&id=66f3c08f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f3c08f",
  null
  
)

export default component.exports